import styled from '@emotion/styled';

const Wrapper = styled.div(({ theme }) => ({
  background: theme.eclipseTier2Color.surface.base,
  padding: theme.eclipseTier1.spacing['20px'],
}));

export const S = {
  Wrapper,
} as const;
